module.exports = __webpack_public_path__ + "static/media/94.dc34738b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/94.jpg
// module id = 1026
// module chunks = 0